import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { RoutesList } from "@/router/routesList";
import { useCreateScheduleMutation } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { ScheduleForm } from "./components/ScheduleForm";
import { convertToCreateScheduleDto } from "./mappers/convertFromViewModel";
import { getEmptySchedule } from "./mappers/getEmptySchedule";
/** Добавление расписания */
export var ScheduleCreatePage = function () {
    var placeId = useParams().placeId;
    var _a = useCreateScheduleMutation(), createScheduleAction = _a[0], createScheduleState = _a[1];
    var saveFormHandler = function (data) {
        try {
            createScheduleAction({
                createScheduleDto: convertToCreateScheduleDto(placeId, data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (createScheduleState.isSuccess) {
            navigate(RoutesList.Place.getPlaceSchedules(placeId));
        }
    }, [createScheduleState.isSuccess]);
    useSetPageData({
        title: "Новый шаблон",
        backLink: RoutesList.Place.getPlaceScheduleTemplates(placeId),
    });
    return (_jsx(ScheduleForm, { data: getEmptySchedule(placeId), mode: "create", onSave: saveFormHandler }));
};
